import { camelize } from 'helpers/syntaxHelper';
import { MantyStatus } from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/constants';

export enum NonRecurrentHypothesisType {
    AGENT = 'agent',
    ENVELOPE = 'envelope',
}

export const DEFAULT_HYPOTHESIS_TYPE_PER_STATUS = {
    [camelize(MantyStatus.TITULAIRE)]: NonRecurrentHypothesisType.AGENT,
    [camelize(MantyStatus.ELECTED_OFFICIAL)]: NonRecurrentHypothesisType.AGENT,
    [camelize(MantyStatus.SEASONAL_CONTRACTOR)]:
        NonRecurrentHypothesisType.AGENT,
    [camelize(MantyStatus.SUBSTITUTE_CONTRACTOR)]:
        NonRecurrentHypothesisType.ENVELOPE,
    [camelize(MantyStatus.ACTIVITY_INCREASE_CONTRACTOR)]:
        NonRecurrentHypothesisType.AGENT,
    [camelize(MantyStatus.WAITING_FOR_TITULAIRE_CONTRACTOR)]:
        NonRecurrentHypothesisType.AGENT,
    [camelize(MantyStatus.VACATAIRE)]: NonRecurrentHypothesisType.AGENT,
    [camelize(MantyStatus.INTERN)]: NonRecurrentHypothesisType.AGENT,
    [camelize(MantyStatus.APPRENTICE)]: NonRecurrentHypothesisType.AGENT,
    [camelize(MantyStatus.CONTRACTOR)]: NonRecurrentHypothesisType.AGENT,
    [camelize(MantyStatus.ASSISTANTE_MATERNELLE)]:
        NonRecurrentHypothesisType.AGENT,
    [camelize(MantyStatus.EMPLOI_AIDE)]: NonRecurrentHypothesisType.AGENT,
    [camelize(MantyStatus.FONCTIONNAIRE_STAGIAIRE)]:
        NonRecurrentHypothesisType.AGENT,
    [camelize(MantyStatus.OTHER)]: NonRecurrentHypothesisType.AGENT,
};
